import { minBy } from 'lodash'
import { ScheduledPostTarget } from 'types'

export const getEarliestPublishedAt = (targets: ScheduledPostTarget[]): string | null => {
  const published = targets.filter((t) => t.status === 'published' && t.published_at)
  return minBy(published, 'published_at')?.published_at ?? null
}
